const LOGIN_API_START = 'LOGIN_API_START';
const LOGIN_API_SUCCESS = 'LOGIN_API_SUCCESS';
const LOGIN_API_FAIL = 'LOGIN_API_FAIL';
const REGISTER_API_START = 'REGISTER_API_START';
const REGISTER_API_SUCCESS = 'REGISTER_API_SUCCESS';
const REGISTER_API_FAIL = 'REGISTER_API_FAIL';
const GET_ME_API_SUCCESS = 'GET_ME_API_SUCCESS';
const GET_ME_API_FAIL = 'GET_ME_API_FAIL';
const VERIFY_ACCOUNT_START = 'VERIFY_ACCOUNT_START';
const VERIFY_ACCOUNT_SUCCESS = 'VERIFY_ACCOUNT_SUCCESS';
const VERIFY_ACCOUNT_FAIL = 'VERIFY_ACCOUNT_FAIL';
const FORGOT_PASSWORD_START = 'FORGOT_PASSWORD_START';
const FORGOT_PASSWORD_SUCCESS = 'FORGOT_PASSWORD_SUCCESS';
const FORGOT_PASSWORD_FAIL = 'FORGOT_PASSWORD_FAIL';
const RESET_PASSWORD_START = 'RESET_PASSWORD_START';
const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
const UPLOAD_PROFILE_PIC_START = 'UPLOAD_PROFILE_PIC_START';
const UPLOAD_PROFILE_PIC_SUCCESS = 'UPLOAD_PROFILE_PIC_SUCCESS';
const UPLOAD_PROFILE_PIC_FAIL = 'UPLOAD_PROFILE_PIC_FAIL';
const LOGOUT_USER_START = 'LOGOUT_USER_START';
const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
const RESET_ALL = 'RESET_ALL';

export const AUTH = {
  LOGIN_API_START,
  LOGIN_API_SUCCESS,
  LOGIN_API_FAIL,
  REGISTER_API_START,
  REGISTER_API_SUCCESS,
  REGISTER_API_FAIL,
  GET_ME_API_SUCCESS,
  GET_ME_API_FAIL,
  VERIFY_ACCOUNT_START,
  VERIFY_ACCOUNT_SUCCESS,
  VERIFY_ACCOUNT_FAIL,
  FORGOT_PASSWORD_START,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_FAIL,
  RESET_PASSWORD_START,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  LOGOUT_USER_START,
  LOGOUT_USER_SUCCESS,
  UPLOAD_PROFILE_PIC_START,
  UPLOAD_PROFILE_PIC_SUCCESS,
  UPLOAD_PROFILE_PIC_FAIL,
  RESET_ALL,
};
